
export const initMicrosoftAuth = () => {
    const msalConfig = {
        auth: {
            clientId: '34048725-7ee2-427d-90d3-eca5210f9fd2',
            authority: 'https://login.microsoftonline.com/common',
            redirectUri: window.location
        },
        cache: {
            cacheLocation: 'sessionStorage', // This configures where your cache will be stored
            storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
        }
    }

    const sendDataOnSignIn = (getMicrosoftData) => {
      const [microsoft_id, first_name, last_name, email] = getMicrosoftData
      document.querySelector('input[name=microsoft_id]').value = microsoft_id
      document.querySelector('input[name=first_name]').value = first_name
      document.querySelector('input[name=last_name]').value = last_name
      document.querySelector('input[name=email]').value = email

      $('.authorization__social').addClass('hidden')
      $('.authorization__microsoft-connected, .authorization__social-connections').removeClass('hidden')
    }

    // Add here scopes for id token to be used at MS Identity Platform endpoints.
    const loginRequest = {
        scopes: ['openid', 'profile', 'User.Read']
    }

    // Create the main myMSALObj instance
    // configuration parameters are located at authConfig.js
    // eslint-disable-next-line no-undef
    const myMSALObj = new Msal.UserAgentApplication(msalConfig)

    function signIn() {
        myMSALObj
            .loginPopup(loginRequest)
            .then(() => {
                let account = myMSALObj.getAccount()

                if (account) {
                    let name = account.name.split(' ')

                    sendDataOnSignIn([account.accountIdentifier, name[0] ?? '', name[1] ?? '', account.userName])
                }
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.log(error)
            })
    }

    $('#microsoftSignIn').on('click', signIn)
}
